export default __webpack_public_path__ + "static/media/1946.ad0eb312.png";